import React from 'react'
import Input from '../../../components/common/Input/Input'
import { getFormErrorByName, getFormErrorMessageByName, hasError, useFormErrorContext } from '../../../utils/context/FormErrorContext'
import { useTranslation } from 'react-i18next'
import SubsidyData from '../../../types/subsidy/SubsidyData'
import AIRPNumberInput from '../../../components/common/AIRPNumberInput/AIRPNumberInput'
import ProfileAttributeTableFragmentGenerator from '../../../utils/TableGenerator/ProfileAttributeTableFragmentGenerator'
import { useShowIncomeLabel } from '../../../utils/ShowIncomeLabelContext'

interface SubsidyTabProps {
    keys: string[],
    data: Record<string, number | null | string>,
    handleCommentChange: (value: string | undefined, name: string) => void
    handleCurrencyChange: (value: number | null, name: keyof SubsidyData) => void
    valueChangeHandler: (newAmt: number | undefined | null, name: string, _oldAmt: number | undefined | null) => void
}

function SubsidyProfileTab(props: SubsidyTabProps) {
    const { keys, data, handleCommentChange, handleCurrencyChange, valueChangeHandler } = props
    const { errors, removeError } = useFormErrorContext()
    const { t } = useTranslation(["ltc_profile_attribute", "pie"])
    const { showIncomeLabel } = useShowIncomeLabel()

    
    return (
        <>
        {data && 
            <table className="table-with-border pie-table accordion-content">
                <thead>
                <tr>
                    <th id="attribute-label" scope="col"></th>
                    <th id="attribute-value" scope="col"></th>
                </tr>
                </thead>
                <tbody>
                {keys.map((key) => {
                    if (key.startsWith("subsidyOther")) {
                    if (key === "subsidyOtherTotal") {
                        return (
                        <tr key={key}>
                            
                            { showIncomeLabel && <td headers="attribute-label" className={hasError(errors, "subsidyOtherDescription") ? "table-error" : ""}>
                            <Input type="text" name={"subsidyOtherDescription"}
                                id={"subsidyOtherDescription"}
                                placeholder={t('headers.subsidyOtherTotal') + " " + t("comment", { ns: "pie" })}
                                value={data["subsidyOtherDescription"] as string}
                                autoComplete="off"
                                hideErrorCross
                                errorMessage={getFormErrorMessageByName(errors, "subsidyOtherDescription")}
                                
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                removeError(getFormErrorByName(errors, "subsidyOtherDescription")?.primaryKey as string)
                                handleCommentChange(e.target.value, e.target.name)

                                }
                                }
                            />
                            </td>}
                            <td headers="attribute-value" className={hasError(errors, "subsidyOtherTotal") ? "table-error" : ""}>
                            <AIRPNumberInput 
                                name="subsidyOtherTotal"
                                symbol='$'
                                textAlign='right'
                                initialValue={data["subsidyOtherTotal"] as number}
                                onChange={(value: number | null) => handleCurrencyChange(value, "subsidyOtherTotal")}/>
                            </td>
                        </tr>
                        )
                    } else {
                        return null
                    }
                    } else {
                    return <ProfileAttributeTableFragmentGenerator key={key} name={key}
                        data={data[key as keyof SubsidyData] as number}
                        fieldType='currency'
                        translationFile='ltc_profile_attribute'
                        valueChangeHandler={valueChangeHandler} isRequiredField={false} />
                    }
                })}
                </tbody>
            </table>}
        </>
    )
}

export default SubsidyProfileTab